'use strict';

require("./SalesOrderRequestsController");
require("./SalesOrderRequestModelChangeController");